import { Skeleton } from '@eika/skeleton';
import './children-list-skeleton.scss';

interface ChildrenListSkeletonProps {
    count?: number;
}

export const ChildrenListSkeleton = ({ count = 3 }: ChildrenListSkeletonProps) => (
    <div className="children-list-skeleton" data-testid="children-list-skeleton">
        {Array.from({ length: count }).map((_, index) => (
            <ChildCardSkeleton key={index} />
        ))}
    </div>
);

const ChildCardSkeleton = () => (
    <div className="child-card-skeleton">
        <div className="child-card-skeleton__text-and-icon">
            <IconSkeleton />
            <TextSkeleton />
        </div>
    </div>
);

const TextSkeleton = () => (
    <div className="child-card-skeleton__text">
        <Skeleton height={16} width="50%" />
        <Skeleton height={16} width="25%" />
    </div>
);

const IconSkeleton = () => <Skeleton height={42} width={42} borderRadius="50%" />;
